export default __webpack_public_path__ + "static/media/selectdropdown-icon.eceb6497.svg";